import printJS from "print-js";
import {useSelector} from "react-redux";
import {Dropdown} from "react-bootstrap";
import React, {cloneElement, Fragment, useState} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPrint, faSpinner} from "@fortawesome/free-solid-svg-icons";
import {selectLang, Translate} from "../../../../app/store/reducers/main/mainReducer";
import {
    saleDownloadContractorLastPaymentPdfAsync,
    saleDownloadItemWithImagePdfAsync,
    saleDownloadMultiWarehousePdfAsync,
    saleDownloadPdfAsync,
    saleDownloadReceipt58PdfAsync,
    saleDownloadReceipt80PdfAsync,
    saleDownloadSkuPdfAsync
} from "../../../../app/store/reducers/warehouse-operation/saleReducer";

const PrintSaleDropdown = ({saleId, children, ...props}) => {
    const [loading, setLoading] = useState(false);
    const lang = useSelector(selectLang);
    const t = Translate;

    const printDefaultPdf = id => {
        setLoading(true);

        saleDownloadPdfAsync({saleId: id})
            .then(response => {
                const blob = new Blob([response], {type: "application/pdf"});
                const blobUrl = window.URL.createObjectURL(blob);
                printJS(blobUrl);
            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => setLoading(false))
    }

    const printSkuPdf = id => {
        setLoading(true);

        saleDownloadSkuPdfAsync({saleId: id})
            .then(response => {
                const blob = new Blob([response], {type: "application/pdf"});
                const blobUrl = window.URL.createObjectURL(blob);
                printJS(blobUrl);
            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => setLoading(false))
    }

    const printContractorLastPaymentPdf = id => {
        setLoading(true);

        saleDownloadContractorLastPaymentPdfAsync({saleId: id})
            .then(response => {
                const blob = new Blob([response], {type: "application/pdf"});
                const blobUrl = window.URL.createObjectURL(blob);
                printJS(blobUrl);
            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => setLoading(false))
    }

    const printSaleItemWithImagePdf = id => {
        setLoading(true);

        saleDownloadItemWithImagePdfAsync({saleId: id})
            .then(response => {
                const blob = new Blob([response], {type: "application/pdf"});
                const blobUrl = window.URL.createObjectURL(blob);
                printJS(blobUrl);
            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => setLoading(false))
    }

    const printMultiWarehousePdf = id => {
        setLoading(true);

        saleDownloadMultiWarehousePdfAsync({saleId: id})
            .then(response => {
                const blob = new Blob([response], {type: "application/pdf"});
                const blobUrl = window.URL.createObjectURL(blob);
                printJS(blobUrl);
            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => setLoading(false))
    }

    const printDefaultReceipt80Pdf = id => {
        setLoading(true);

        saleDownloadReceipt80PdfAsync({saleId: id})
            .then(response => {
                const blob = new Blob([response], {type: "application/pdf"});
                const blobUrl = window.URL.createObjectURL(blob);
                printJS(blobUrl);
            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => setLoading(false))
    }

    const printDefaultReceipt58Pdf = id => {
        setLoading(true);

        saleDownloadReceipt58PdfAsync({saleId: id})
            .then(response => {
                const blob = new Blob([response], {type: "application/pdf"});
                const blobUrl = window.URL.createObjectURL(blob);
                printJS(blobUrl);
            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => setLoading(false))
    }

    return (
        <Dropdown {...props} autoClose="outside">
            <Dropdown.Toggle bsPrefix="toggle" variant="falcon-default" size="sm" disabled={loading}>
                {!!children
                    ?
                    <div>
                        {!!loading && <FontAwesomeIcon className="me-1" pulse={true} icon={faSpinner}/>}
                        {!loading && cloneElement(children, {...children.props})}
                    </div>
                    :
                    <div>
                        {!!loading && <FontAwesomeIcon className="me-1" pulse={true} icon={faSpinner}/>}
                        {!loading && <FontAwesomeIcon className="me-1" icon={faPrint}/>}

                        <span className="d-none d-sm-inline-block">
                            {t(lang, 'warehouse.operation.item.common.print')}
                        </span>
                    </div>
                }
            </Dropdown.Toggle>
            <Dropdown.Menu className='py-2'>
                <Fragment>
                    <Dropdown.Header className="text-black">{t(lang, 'warehouse.operation.item.common.printing_invoice')}</Dropdown.Header>
                    <Dropdown.Item className="ps-4" disabled={loading} onClick={() => printDefaultPdf(saleId)}>
                        {t(lang, 'warehouse.operation.item.common.print_invoice')}
                    </Dropdown.Item>
                    <Dropdown.Item className="ps-4" disabled={loading} onClick={() => printSkuPdf(saleId)}>
                        {t(lang, 'warehouse.operation.item.common.print_sku_invoice')}
                    </Dropdown.Item>
                    <Dropdown.Item className="ps-4" disabled={loading} onClick={() => printContractorLastPaymentPdf(saleId)}>
                        {t(lang, 'warehouse.operation.item.common.print_contractor_last_payment_invoice')}
                    </Dropdown.Item>
                    <Dropdown.Item className="ps-4" disabled={loading} onClick={() => printSaleItemWithImagePdf(saleId)}>
                        {t(lang, 'warehouse.operation.item.common.print_sale_item_with_image_invoice')}
                    </Dropdown.Item>
                    <Dropdown.Item className="ps-4" disabled={loading} onClick={() => printMultiWarehousePdf(saleId)}>
                        {t(lang, 'warehouse.operation.item.common.print_multi_warehouse_invoice')}
                    </Dropdown.Item>
                </Fragment>
                <Fragment>
                    <Dropdown.Header className="text-black">{t(lang, 'warehouse.operation.item.common.printing_receipt')}</Dropdown.Header>
                    <Dropdown.Item className="ps-4" disabled={loading} onClick={() => printDefaultReceipt80Pdf(saleId)}>
                        {t(lang, 'warehouse.operation.item.common.print_receipt_80')}
                    </Dropdown.Item>
                    <Dropdown.Item className="ps-4" disabled={loading} onClick={() => printDefaultReceipt58Pdf(saleId)}>
                        {t(lang, 'warehouse.operation.item.common.print_receipt_58')}
                    </Dropdown.Item>
                </Fragment>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default PrintSaleDropdown;